import * as fathom from "fathom-client";
function safeFathomCall(fathomFunction) {
  return (...args) => {
    if (import.meta.client) {
      return fathomFunction(...args);
    }
  };
}
const fathomFunctions = [
  "blockTrackingForMe",
  "enableTrackingForMe",
  "isTrackingEnabled",
  "setSite",
  "trackEvent",
  "trackPageview"
];
export function useFathom() {
  return fathomFunctions.reduce((api, functionName) => {
    api[functionName] = safeFathomCall(fathom[functionName]);
    return api;
  }, {});
}
